import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Avatar from '@mui/material/Avatar'
import defaultAvatar from 'assets/images/default_avatar.png'

const AdminGroupCard = ({ item, handleOpenAddAdminModal, keyIndex, totalItems, sx }) => {
  const permissionsString = item?.permissions?.map((item) => item?.id).sort()

  let firstPermissions =
    permissionsString?.includes(1) ||
    permissionsString?.includes(2) ||
    permissionsString?.includes(3) ||
    permissionsString?.includes(4) ||
    permissionsString?.includes(13) ||
    permissionsString?.includes(14) ||
    permissionsString?.includes(15)
  let secondPermissions = permissionsString?.includes(5) || permissionsString?.includes(6)
  let thirdPermissions =
    permissionsString?.includes(7) ||
    permissionsString?.includes(8) ||
    permissionsString?.includes(9)
  let fourthPermissions = permissionsString?.includes(18)

  const textPermission = [
    firstPermissions && 'Company Management',
    secondPermissions && 'Staff Management',
    thirdPermissions && 'Payroll',
    fourthPermissions && 'Recruitment Management',
  ]
    .filter((x) => x)
    .toString()
    .replaceAll(',', ', ')

  return (
    <Box
      px={2}
      py={2}
      display="flex"
      flexDirection={{ xs: 'column', lg: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', lg: 'center' }}
      sx={{ ...sx }}
    >
      <Box display="flex" flexDirection={{ xs: 'column', lg: 'row' }}>
        <Box
          height="100%"
          display="flex"
          alignItems="center"
          mr={2}
          gap={2}
          width={{ xs: '100%', lg: '400px' }}
        >
          <Avatar
            src={item?.profile_image_url || defaultAvatar}
            alt="..."
            width="40px"
            height="40px"
            sx={{ objectFit: 'cover' }}
            borderRadius="50%"
          />
          <Box
            height="100%"
            display="flex"
            flexDirection="column"
            alignItems="left"
            justifyContent="center"
            flex={1}
            gap={0.5}
          >
            <Typography variant="body1" width={'100%'}>
              {item?.name}
            </Typography>
            <Typography variant="body2" color="light-gray-text.main" width={'100%'}>
              {item?.designation}
            </Typography>
          </Box>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          flex={1}
          pt={{ xs: 1, lg: 0 }}
          px={{ xs: 1, lg: 0 }}
        >
          <Typography color="light-gray-text.main" variant="body1">
            {item?.super_admin ? 'Super Admin' : textPermission}
          </Typography>
        </Box>
      </Box>
      {/* <AdxButton variant={'ghost'} onClick={handleOpenAddAdminModal}>Manage</AdxButton> */}
      <Typography
        onClick={handleOpenAddAdminModal}
        mr={2}
        noWrap
        variant="subtitle1"
        color={'alternate.main'}
        sx={{
          textDecoration: 'underline',
          fontWeight: 'medium',
          cursor: 'pointer',
        }}
      >
        Manage
      </Typography>
    </Box>
  )
}

export default AdminGroupCard
